import CloseIcon from '@mui/icons-material/Cancel'
import {Control, Controller, FieldError,ControllerProps, Path} from 'react-hook-form'
import { Checkbox, Chip, FormControl, FormControlProps, FormHelperText, InputLabel, ListItemText,MenuItem,Select,SelectProps} from '@mui/material'
import {FieldValues} from 'react-hook-form/dist/types/fields'

export type MultiSelectElementProps = Omit<SelectProps , 'value' > & {
    options: any[]
    label?: string
    itemKey?: string
    itemValue?: string
    itemLabel?: string
    required?: boolean
    validation?: ControllerProps['rules']
    name: string
    minWidth?: number
    menuMaxHeight?: number
    menuMaxWidth?: number
    helperText?: string
    control?: Control<any,any>
    showCheckbox?: boolean
    showChips?: boolean
    disabled?: boolean
    maxLength?: number
    onChange?: (vaue:any) =>void
    valueKey?: string
    labelKey?: string
    objectOnChange?: boolean
}

// const ITEM_HEIGHT = 48
// const ITEM_PADDING_TOP = 8

export default function CustomMultiSelectComponent({
    options =[],
    label,
    itemKey = 'id',
    itemValue = '',
    itemLabel = 'label',
    required,
    validation = {},
    name,
    disabled,
    maxLength,
    control,
    showCheckbox,
    showChips,
    // helperText,
    fullWidth,
    valueKey='value',
    labelKey='name',
    objectOnChange,
    sx,
    ...rest
    }: MultiSelectElementProps): JSX.Element {

    if (required) {
        validation.required = `This field is required`
    }
    
    const getValues = (value : any) => {
        let values :any[] = []                                
        for (var va in value){
            values.push(value[va].trim())
        }
        return values
    }
    
    return (
        <div style={rest.style} >
        <Controller
            name={name}
            rules={validation}
            control={control}
            render={({field: {value, onChange, onBlur}, fieldState: {invalid, error}}) => 
                <>
                    <FormControl size="small" className={'lowHeight'} id={name + '_formControl'} error={!!error} fullWidth>
                       <InputLabel id={name + 'Label'}>{required ? label+ ' *' : label}</InputLabel> 
                        <Select
                            id={rest.id || `select-multi-select-${name}`}
                            multiple
                            label={required ? label+ ' *' : label}
                            error={invalid}
                            // value={value || []}
                            value = {getValues(value)}
                            required={required}
                            onChange={onChange}
                            onBlur={onBlur}
                            renderValue={typeof rest.renderValue === 'function' ? rest.renderValue : showChips ? (selected) => (
                                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                    {(selected as any[] || []).map((selectedValue) => (
                                        <Chip
                                            key={selectedValue}
                                            label={selectedValue}
                                            style={{display: 'flex', flexWrap: 'wrap'}}
                                            onDelete={() => {
                                                onChange(value.filter((i: any) => i.trim() !== selectedValue))
                                                // setValue(name, formValue.filter((i: any) => i !== value), { shouldValidate: true })
                                            }}
                                            deleteIcon={<CloseIcon
                                                onMouseDown={(ev) => {
                                                    ev.stopPropagation()
                                                }}/>
                                            }
                                        />
                                    ))}
                                </div>
                            // ) : (selected) => Array.isArray(selected) ? selected.join(', ') : ''}
                            ) : (selected) => Array.isArray(selected) ? selected: ''}
                        >
                            {options.map((item) => {
                                const val: string | number = item[itemValue || itemKey] || item
                                let values :any[] = []                                
                                for (var va in value){
                                    values.push(value[va].trim())
                                }
                                const isChecked = Array.isArray(values) ? values.includes(val) : false
                                return (
                                    <MenuItem
                                        key={val}
                                        value={val}
                                        sx={{
                                            fontWeight: (theme) => isChecked ? theme.typography.fontWeightBold : theme.typography.fontWeightRegular
                                        }}
                                    >
                                        {showCheckbox && <Checkbox checked={isChecked}/>}
                                        <ListItemText primary={item[itemLabel] || item}/>
                                    </MenuItem>
                                )
                            })}
                        </Select>
                        {!!error  && <FormHelperText>{error?.message}</FormHelperText>}
                    </FormControl>
                </> 

            }
        />
    </div>
    )
}